export const ADD_USER_ACCOUNT_MODAL_I18N_PREFIX = "features.user_management.components.add_user_account_modal";

export const ADD_USER_ACCOUNT_MODAL_I18N_KEYS = {
  add_user:                 "add_user",
  edit_user:                "edit_user",
  name_label:               "name_label",
  email_label:              "email_label",
  password_label:           "password_label",
  designation_label:        "designation_label",
  invalid_email_format:     "invalid_email_format",
  invalid_password:         "invalid_password",
  email_already_exists:     "email_already_exists",
  new_user_added_header:    "new_user_added_header",
  new_user_add_paragraph_1: "new_user_add_paragraph_1",
  new_user_add_paragraph_2: "new_user_add_paragraph_2"
};




// WEBPACK FOOTER //
// ./src/features/user-management/components/constants/i18n/AddUserAccountModali18nConstants.js